import React, { useContext, useState, useEffect} from 'react'
import { connect } from 'react-redux'
import { Loader, Item, Button, Icon } from 'semantic-ui-react'
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { backendService } from '../../services/backendService'

const ActiveSubscriptionItem = (props) => {

  const languageContext = useContext(LanguageContext);
  const {subscriptionItem, subscription, restoreSubscriptionRenewal, askForCancelSubscriptionConfirm } = props;
  const user = props.auth.user;

  const [usedQueries, setUsedQueries] = useState(0);
  const plan = subscriptionItem && subscriptionItem.price ? subscriptionItem.price : subscriptionItem && subscriptionItem.plan ? subscriptionItem.plan : null
  const couponValidUntil = subscription && subscription.discount && subscription.discount.end ? new Date(subscription.discount.end * 1000).toLocaleDateString() : '';
  const cost =  plan && plan.unit_amount ? plan.unit_amount : plan && plan.amount ? plan.amount : plan && plan.tiers ? plan.tiers[0].flat_amount : 0;  
  const availableQueries = plan && plan.metadata.query_count ? plan.metadata.query_count : user && user.plan_queries ? user.plan_queries : 0;   
  const subscriptionEnd = subscription ? new Date(subscription.current_period_end * 1000).toLocaleDateString() : null;
  const licenseEnd = subscription && subscription.current_period_end ? new Date(subscription.current_period_end * 1000).toLocaleDateString() : user && user.license_expire_at ? new Date(Date.parse(user.license_expire_at)).toLocaleDateString() : null;
  const licenseExpired = subscription && subscription.current_period_end ? new Date(subscription.current_period_end * 1000).toLocaleDateString() : user && user.license_expire_at ? Date.parse(user.license_expire_at) <= new Date() : true;
  const trialEnd = user.trial_expires_at ? new Date(Date.parse(user.trial_expires_at)).toLocaleDateString() : null;
  const trialExpired = user.trial_expires_at ? Date.parse(user.trial_expires_at) <= new Date() : true;
  

  useEffect(() => {
    getUsedQueries();
  }, [] )

  const getUsedQueries = async () => {
    try {
        const queriesResp = await backendService.get(`/api/users/check`);
        if (queriesResp && queriesResp.data)
            setUsedQueries(queriesResp.data.count);
    } catch (exc) {
        console.error(exc);
    }
  }

  return (      
      <>
        {subscriptionItem ?  
            <Item.Group divided>
            <Item >
                <Item.Content>
                    <Item.Header>
                    {Translate(languageContext, plan.nickname)} - 
                    {subscription.status === 'active' || subscription.status === 'trialing' ? 
                                <>
                                <span style={{color: 'green'}}> <Text tid='subscription_active' /> </span> 
                                { subscription.cancel_at_period_end === false ? 
                                    <> 
                                        - <Text tid='subscription_will_renew_on' /> {subscriptionEnd}
                                    </> :
                                    <> 
                                        - <Text tid='subscription_will_expire_on' /> {subscriptionEnd}
                                    </> 
                                }  
                                </>
                                : 
                                <span style={{color: 'red'}}> <Text tid='subscription_not_active' /></span>
                    }
                    </Item.Header>
                    <Item.Meta>
                    {subscription.discount ? 
                        <>
                            <div style={{color: 'red'}}><del>{(cost/100.0).toFixed(2)}<Text tid={plan.currency} /></del></div>
                            <div style={{color: 'green'}}>
                            {subscription.discount.coupon.amount_off && ((cost - subscription.discount.coupon.amount_off)/100.0).toFixed(2)}
                            {subscription.discount.coupon.percent_off && ((cost - cost*subscription.discount.coupon.percent_off/100.0)/100.0).toFixed(2)}<Text tid={plan.currency} /> 
                            {plan.recurring || plan.interval ? 
                                <> / <Text tid={plan.interval ? plan.interval : plan.recurring.interval} /> </> :
                                '' }
                            { couponValidUntil &&
                                <><Text tid='subscription_coupon_valid_until' /> {couponValidUntil}</>
                            }
                            </div>
                        </>
                        : 
                        <>
                            {(cost/100.0).toFixed(2)}<Text tid={subscriptionItem.plan.currency} /> {plan.recurring || plan.interval ? 
                                                                                                    <> / <Text tid={plan.interval ? plan.interval : plan.recurring.interval} /> </> :
                                                                                                    '' }
                        </>
                    }
                    </Item.Meta>
                    <Item.Description>
                        {subscription.cancel_at_period_end ? 
                         restoreSubscriptionRenewal && <Button 
                            style={{right: '5px', minWidth: '228px'}}
                            primary 
                            icon 
                            labelPosition='right'
                            className='lisia-blue' 
                            onClick={restoreSubscriptionRenewal} floated='right'>
                            <Text tid='subscription_restore_renewal' />
                            <Icon name='checked calendar' /> 
                        </Button> :
                        askForCancelSubscriptionConfirm && <Button 
                            style={{right: '5px', minWidth: '228px'}}
                            primary 
                            icon 
                            labelPosition='right'
                            className='lisia-blue' 
                            onClick={askForCancelSubscriptionConfirm} floated='right'>
                            <Text tid='subscription_cancel_renewal' />  
                            <Icon name='delete calendar' /> 
                        </Button> 
                        }
                        {plan.recurring || plan.interval ? 
                        <> {availableQueries >= 0 && <>
                                                                <Text tid='subscription_periodic_plan_active_description_prefix' />
                                                                    {availableQueries} <Text tid='subscription_periodic_plan_description_suffix' />
                                                                <Text tid={plan.interval ? plan.interval : plan.recurring.interval} />.<br/>
                                                                </>
                            }
                                                                
                        <i><Text tid='subscription_expires_on' /> {subscriptionEnd}</i>
                        <br/>
                        <i> <Text tid='subscription_query_count_message_prefix' /> {usedQueries} { availableQueries >= 0 ? <><Text tid='subscription_query_count_message_suffix' />  {availableQueries} </> : <Text tid='queries' /> }</i>                                   
                        <br/>
                        {!trialExpired && 
                            <> 
                            <i style={{color:'green'}}> <Text tid='subscription_activation_message_prefix' /> {trialEnd} {
                                subscription.cancel_at_period_end === true ?
                                <> </> : <> <Text tid='subscription_activation_message_suffix' /> </>
                            } </i>                                    
                            <br/>
                            </> 
                        }
                        <b><i> 
                            { subscription.cancel_at_period_end === true ? <> <Text tid='subscription_wont_renew_on_expiration' />.</> 
                                                                                : 
                                                                                    <> {Translate(languageContext, 'subscription_renews_on_expiration')
                                                                                        .replace(/\${interval}/, Translate(languageContext, plan.interval ? plan.interval : plan.recurring.interval)) } .
                                                                                    </>
                            }  
                        </i></b>
                        </> 
                        
                        : 
                        <> <Text tid='subscription_trial_offer' /> {plan.metadata.query_count} <Text tid='user_profile_queries' />{plan.metadata.trial_period_days ? 
                            <>, <Text tid='subscription_expires_after' /> {plan.metadata.trial_period_days} <Text tid='days' /></> : '' }. 
                            <br/>                                    
                        </>
                        }
                        
                    </Item.Description>                                            
                </Item.Content>
                </Item>
            </Item.Group>
            :
            <Item.Group divided>
            <Item>
                <Item.Content>
                <Item.Header>{Translate(languageContext, 'subscription_no_plan')}</Item.Header>                            
                <Item.Description>
                {(!trialExpired || !licenseExpired) && 
                    <> 
                    { availableQueries && 
                    <>
                        <i> <Text tid='subscription_query_count_message_prefix' /> {usedQueries} { availableQueries >= 0 ? <><Text tid='subscription_query_count_message_suffix' />  {availableQueries} </> : <Text tid='queries' /> }</i> 
                        <br/>
                    </>
                    }
                    { !trialExpired && 
                        <>
                        <i style={{color:'green'}}> <Text tid='subscription_activation_message_prefix' /> {trialEnd} </i>                                    
                        <br/>
                        </>
                    }
                    { !licenseExpired && 
                        <>
                        <i> <Text tid='subscription_license_will_expire_on' /> {licenseEnd} </i>                                    
                        <br/>
                        </>
                    }
                    </> 
                }
                </Item.Description>                                            
                </Item.Content>
            </Item>
            </Item.Group>                      
        }
      </>     
  )

}

const mapStateToProps = (state) => ({
  auth: state.auth
})

export default connect(mapStateToProps)(ActiveSubscriptionItem)